// extracted by mini-css-extract-plugin
module.exports = {"evidence-table-info-content":"EvidenceSummary_evidence-table-info-content__2UUB_"};